import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalContentText,
  ModalTitle,
} from '@deere/fuel-react';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import './popupModel.css';
import {ACCOUNT_SELECTION_SHOWN_KEY} from '../../utils/constant';

const PopupModal = ({
  title,
  description,
  action,
  visible,
  setVisible,
  signoutPopup,
  type,
  isSecurityVerification,
  unsecureRoute,
}) => {
  const {t} = useTranslation();
  const navigate = useNavigate();

  const signOut = () => {
    if (isSecurityVerification && unsecureRoute) {
      navigate('/');
    } else {
      localStorage.removeItem('hasLoggedInBefore');
      localStorage.removeItem(ACCOUNT_SELECTION_SHOWN_KEY);
      signoutPopup.signOut({
        postLogoutRedirectUri: `${window.location.origin}/signOut`,
      });
    }
  };

  const handleClose = () => {
    setVisible(false);
  };
  return (
    <Modal
      className="SignOutPopup"
      open={visible}
      onClose={handleClose}
      aria-labelledby="alert-Modal-title"
      aria-describedby="alert-Modal-description"
      fullWidth={true}
    >
      <ModalTitle
        id={`${
          type === 'secondary'
            ? 'security-ver-Modal-title'
            : 'alert-Modal-title'
        }`}
      >
        {title}
      </ModalTitle>
      <ModalContent>
        <ModalContentText id="alert-Modal-description">
          {description}
        </ModalContentText>
      </ModalContent>
      <ModalActions
        id={`${type === 'secondary' ? 'secondary-modal-action' : ''}`}
      >
        <Button
          id="closeButton"
          onClick={handleClose}
          variant={`${type === 'secondary' ? 'secondary' : 'primary'}`}
        >
          {t('CANCEL')}
        </Button>
        <Button
          id={`${type === 'secondary' ? 'secondary-sec-ver' : 'primaryBtn'}`}
          onClick={signOut}
          variant="secondary"
        >
          {action}
        </Button>
      </ModalActions>
    </Modal>
  );
};

PopupModal.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
};

export default PopupModal;
